import * as types from 'actions/actionTypes';
import * as authenticationServices from 'services/apis/calAmp/authenticationServices';
import 'url-search-params-polyfill';
import {beginAjaxCall, ajaxCallError, ajaxSignInCallError } from './ajaxStatusActions';
import * as toastr from '../../node_modules/toastr/build/toastr.min.js';
import * as cookieServices from 'services/cookies/cookieServices';
import * as redirectServices from 'services/url/redirectServices';
import * as entityServices from 'services/apis/calAmp/entityServices';
import * as miscServices from 'services/miscServices';
import {getSystemUnits} from './systemUnitsActions';

var I18n = require('react-redux-i18n').I18n;

/**
 * funzione da chiamare all'avvio dell'applicativo. esegue check sul cookie authToken di CalAmp chiamando il
 * getcurrentuser, se fallisce allora verrà redirezionato alla pagina di login
*/
export function initIsAuthenticated(){
    return function(dispatch){

        /*
            avviso che c'è un check sull'init
        */
        dispatch({
            type: types.LOAD_INIT_CURRENTUSER_REQUEST
        })

        dispatch(beginAjaxCall());

        authenticationServices.getCurrentUser()
        .then(function (response) {
            console.log("initIsAuthenticated - getCurrentUser response");

            /*
                carico nello state le info sull'utente + account di appartenenza
            */
            dispatch({
                type: types.LOAD_INIT_CURRENTUSER_SUCCESS,
                data: response.data.response.results[0].user
            })

            console.log("initIsAuthenticated - getCurrentUser");
            console.info(response.data.response.results[0].user.account);

            /*
                se ha un account allora faccio partire la
                ricerca dei subaccount - utile per il controllo di selezione acocunt del search form
            */
            if(response.data.response.results[0].user.account){
                const accountId = miscServices.getIdFromHref(response.data.response.results[0].user.account.href);
                dispatch(fetchSubAccounts(accountId));
                dispatch(getSystemUnits(response.data.response.results[0].user.systemOfUnits.value));
            }

        })
        .catch(function (error) {
            /*
                l'utente non è loggato, non carico nulla nello state e l'utente verrà inviato automaticamente
                alla pagina di login
            */
            console.error("isAuthenticated : user not logged");

            dispatch({
                type: types.LOAD_INIT_CURRENTUSER_ERROR
            })
            /*
                non mostro alcun messaggio, verrà redirezionato in automatico alla
                pagina di login
            */
            dispatch(ajaxCallError());
        });
    };
}

/**
 * definizione delle action per le chiamate relative allo user
 */
export function userLoggedIn(){
    return {type: types.USER_LOGGED_IN}
}

export function userLoggedOut(){
    return {type: types.USER_LOGGED_OUT}
}

export function logOut(){
    return function(dispatch){

        /*
            notifico che l'utente non è + loggato
        */
        cookieServices.deleteAppCookie();
        cookieServices.deleteJasperSessionCookie();
        cookieServices.deleteLanguageCodeCookie();
        dispatch(userLoggedOut());
        // se non è loggato allora eseguo redirect alla pagina di login
        redirectServices.redirectToLogin();

    };
}

export function checkUser(){
    return function(dispatch){

        /*
            notifico che tra poco ci sarà una chiamata in corso
        */
        dispatch(userLoggedIn());
    };
}

export function fetchSubAccountsRequest(parentId){
    return {type: types.FETCH_SUBACCOUNTS_REQUEST, data: {parentId}}
}

export function fetchSubAccountsSuccess(data){
    return {type: types.FETCH_SUBACCOUNTS_SUCCESS, data}
}

export function fetchSubAccountsError(){
    return {type: types.FETCH_SUBACCOUNTS_ERROR}
}

export function saveApplication(data){
    return {type: types.APP_SAVEAPPLICATION_SUCCESS, data}
}

export function getCurrentUser(){
    return function(dispatch){
        dispatch({
            type: types.LOAD_CURRENTUSER_REQUEST
        })
        dispatch(beginAjaxCall());

        authenticationServices.getCurrentUser()
        .then(function (response) {

            /*
                con questo dispatch salvo nello state l'account di appartenenza
                poi con FetchSubAccounts cerco i subaccounts
            */
            dispatch({
                type: types.LOAD_CURRENTUSER_SUCCESS,
                data: response.data.response.results[0].user
            })

            console.log("getCurrentUser");
            console.info(response.data.response.results[0].user.account);

            if(response.data.response.results[0].user.account){
                const accountId = miscServices.getIdFromHref(response.data.response.results[0].user.account.href);
                dispatch(fetchSubAccounts(accountId));
                dispatch(getSystemUnits(response.data.response.results[0].user.systemOfUnits.value));
            }

        })
        .catch(function (error) {
            dispatch(ajaxCallError(error));
            dispatch({
                type: types.LOAD_CURRENTUSER_ERROR
            })
        });
    };
}

export const login = data => dispatch => {
    dispatch({
        type: types.USER_LOGGING_IN
    })
    dispatch(beginAjaxCall());

    authenticationServices.login(data.username, data.password)
        .then(function (response) {

            toastr.success(I18n.t('GLOBAL.operationSuccess'));
            console.log("dispatching USER_LOGGED_IN");
            console.info(data);
            dispatch({
                type: types.USER_LOGGED_IN,
                data: data
            })

            /*
                se login è OK allora
                salvo in un cookie l'application passata data.selectedApp che contiene
                info su baseUri + appKey
            */
            cookieServices.saveAppCookie(data.username, data.password, data.selectedApp);

            dispatch(saveApplication(data.selectedApp));

            dispatch(getCurrentUser());

            /*
                dopo aver salvato le info sull'utente redirect alla home
                window.location.search = '?redirect=%2Ficn'
            */
            redirectServices.redirectTo();

        })
        .catch(function (error) {
            dispatch({
                type: types.USER_LOGIN_ERROR,
                error: error
            })

            dispatch(ajaxSignInCallError(error));

        });

}

/**
 * estrae i sub accounts
 * @param {account id} parentId
 */
export function fetchSubAccounts(parentId){

    return function(dispatch){
        dispatch(fetchSubAccountsRequest(parentId))
        dispatch(beginAjaxCall());

        entityServices.fetchSubAccounts(parentId)
        .then(function (response) {
            var data = {parentId, subAccounts: response.data.response.results[0].account.subAccounts};
            dispatch(fetchSubAccountsSuccess(data))
        })
        .catch(function (error) {
            dispatch(fetchSubAccountsError())
            dispatch(ajaxCallError(error));
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/userActions.js